import {
  Action,
  AnyAction,
  combineReducers,
  configureStore,
  Reducer,
  ThunkAction
} from '@reduxjs/toolkit'
import {getConfig} from '../services/config'
import {guestCheckinApi} from '../services/guestCheckinApi'
import authReducer from './authSlice'
import userReducer from './userSlice'
import helpReducer from './helpSlice'
import reservationReducer from './reservationSlice'
import {getLogger} from '../services/logging'
const {reduxDevTools} = getConfig()

const logger = getLogger('ReduxStore')

const combinedReducer = combineReducers({
  auth: authReducer,
  help: helpReducer,
  reservation: reservationReducer,
  user: userReducer,
  [guestCheckinApi.reducerPath]: guestCheckinApi.reducer
})

let rootState: RootState

const isSignOut = ({type, payload}: AnyAction) =>
  type === 'auth/setAuthenticated' && payload === false

const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
  // sign out
  if (isSignOut(action)) {
    state = {} as RootState
  }
  rootState = combinedReducer(state, action)

  // log all changes to redux state
  logger.debug({
    message: 'Redux state changed',
    data: {action, state: rootState, previousState: state}
  })

  return rootState
}

export function getRootState() {
  return rootState
}

export const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    return getDefaultMiddleware().concat([guestCheckinApi.middleware])
  },
  devTools: reduxDevTools
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>
